import * as React from 'react';
import * as classnames from 'classnames';

function InfoPopup(props) {
    const {
        full = false,
        title,
        content,
        icon,
        sidebarBackgroundColor,
        sidebarTitle,
        sidebarText,
        sidebarIcon,
        show,
        close,
        footer,
        responsiveSize
    } = props;

    if (show) {
        return (
            <div className="info-popup" onClick={close}>
                <div
                    className={classnames('info-popup--container', {
                        responsive: responsiveSize
                    })}
                    onClick={(event) => {
                        event.stopPropagation();
                    }}
                >
                    {full && (
                        <div
                            className="info-popup--sidebar"
                            style={{
                                backgroundColor: sidebarBackgroundColor
                            }}
                        >
                            <img src={sidebarIcon} alt="Icon"></img>
                            <h1>{sidebarTitle}</h1>
                            <p>{sidebarText}</p>
                        </div>
                    )}
                    <div
                        className={classnames('info-popup--content', {
                            'half-rounded': full,
                            responsive: responsiveSize
                        })}
                    >
                        <div className="info-popup--content--header">
                            {icon && <img src={icon} alt="Error Icon" />}
                            {title && <h1 className="title">{title}</h1>}
                        </div>
                        {close && <i className="nx nx-close" onClick={close} />}
                        <div className="info-popup--content--body">
                            {content}
                        </div>
                        <div className="info-popup--content--footer">
                            {footer}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return null;
}

export default InfoPopup;
